import * as React from 'react';
import { Pill } from '../../../../web/components-v2/Pill';

interface IProps {
	value: number;
}

export const RulePriority: React.FC<IProps> = ({ value }) => {
	return <Pill variant='label' color='gray' label={String(value)} />;
};
